import { BulkActionMenuItemInjectedProps, FilterValues, KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { CustomComponent } from "@kaltura/mediaspace-shared-ui";
import { Button, Menu, useMenu } from "@kaltura/ds-react-components";
import { translate, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { MoreVertical24Icon } from "@kaltura/ds-react-icons";
import { useTheme } from "@kaltura/mediaspace-shared-styled";

export interface ActionsDropdownProps {
    menuItems: KmsTypeComponent<any, BulkActionMenuItemInjectedProps>[];
    entryIds: string[];
    reloadMedia: () => void;
    filterValues?: FilterValues;
}

/**
 * search results actions dropdown
 */
const ActionsDropdown = (props: ActionsDropdownProps) => {
    const { menuItems, entryIds, reloadMedia, filterValues } = props;

    const { close, buttonProps, menuProps } = useMenu({
        menuId: "actions-bar-actions-dropdown-menu",
    });

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

    return (
        <>
            <Button
                {...buttonProps}
                id={"actions-bar-actions-button"}
                variant={"borderless"}
                color={"secondary"}
                size={"medium"}
                aria-label={isSmallScreen ? translate("Actions") : translate("More actions")}
                startIcon={<MoreVertical24Icon />}
            >
                {isSmallScreen ? translate("Actions") : translate("More actions")}
            </Button>

            <Menu
                {...menuProps}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                aria-labelledby={"actions-bar-actions-button"}
            >
                {menuItems.map((component, index) => (
                    <CustomComponent
                        key={index}
                        component={component}
                        errorFallback={<></>}
                        entryIds={entryIds}
                        reloadMedia={reloadMedia}
                        onCloseMenu={close}
                        filterValues={filterValues}
                    />
                ))}
            </Menu>
        </>
    );
};

export default ActionsDropdown;
